import './FinanceCalculator.scss';
import { useState } from 'react';
import { AppBar, Button, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import FinanceCalculatorForm from './FinanceCalculatorForm/FinanceCalculatorForm';
import FinanceCalculatorResults from './FinanceCalculatorResults/FinanceCalculatorResults';
import { IFinanceCalculatorState, defaultFormState } from '../../models/finance-calculator.model';
import { getDesignTokens } from '../shared/palette';
import ContactMeForm from './ContactMeForm/ContactMeForm';
import { Col, Row } from 'reactstrap';

  const FinanceCalculator = () => {
    const searchParams = new URLSearchParams(document.location.search);
    const initMode = (searchParams.get('mode')?.toLocaleLowerCase() === "dark" ? "dark" : "light");
    const [state, setState] = useState<IFinanceCalculatorState>(
        { mode: initMode, 
          submitted: false,
          formdata: defaultFormState,
          resultsdata: undefined,
          selectedIndex: -1,
          contacting: false,
          contactsubmitted: false, 
          contactdata: undefined,
        }
    );
    const darkModeTheme = createTheme(getDesignTokens(state.mode));

    const updateState = (newState: IFinanceCalculatorState) => {
        setState((prevState: IFinanceCalculatorState) => {
            const overallNewState = { ...prevState, ...newState };
            // console.log("FinanceCalculator.onSubmit: setState to " + JSON.stringify(overallNewState));
            return overallNewState;
        });
    }

    const onContactMe = () => {
        updateState({ ...state, contacting: true, contactsubmitted: false });
    };

    const onReset = () => {
        updateState({ ...state, submitted: false, formdata: {...state.formdata, identity: undefined, derivative: undefined}, selectedIndex: -1, contacting: false, contactsubmitted: false });
    };

    return (
        <>
            <ThemeProvider theme={darkModeTheme}>
            <CssBaseline />

            {state.contacting ? (
                <>
                    {state.contactsubmitted ? (
                    <>
                        <div className="thank-you-message">
                            <div>Thank you for getting in touch.</div>
                            <div>A representative will contact you shortly.</div>
                            {state.contactdata && state.contactdata.emailSpecifics && (<div>A summary of this quote has been emailed to you.</div>)}
                            <br/>

                            <Row fullWidth>
                                <Col>
                                    <Button type="button" variant="contained" color="secondary" onClick={onReset}>Return to the start</Button>
                                </Col>
                            </Row>
                        </div>
                    </>
                    ) : (
                        <ContactMeForm state={state} updateState={setState} />
                    )}
                </>
            ) : (
                <>
                {state.submitted ? (
                    <>
                        <div className="financeCalculatorResults">
                            <FinanceCalculatorResults state={state} updateState={updateState} onApply={onContactMe} />

                            <div className="appBarSpacer">&nbsp;</div>

                            <AppBar position="fixed" sx={{ top: 'auto', bottom: 0, background: (state.mode === 'dark' ? 'rgba(33,33,33,0.7)' : 'rgba(255,255,255,0.7)'), boxShadow: 'none' }}>
                                <Row fullWidth>
                                <Col>
                                    {false && (
                                        <Button type="button" variant="contained" color="primary" disabled={state.selectedIndex === -1} onClick={onContactMe}>Apply Now</Button>
                                    )}
                                </Col>
                                <Col className="makeChanges">
                                    <Button type="button" variant="contained" color="secondary" onClick={onReset}>Make Changes</Button>
                                </Col>
                                </Row>
                            </AppBar>
                        </div>
                    </>
                ) : (
                    <FinanceCalculatorForm state={state} updateState={setState} />
                )}
                </>
            )}

            </ThemeProvider>
        </>
    );
};

export default FinanceCalculator;
